import { acceptFamilyInvite } from '@jotta/grpc-connect-openapi/customerQuery'
import { useMutation } from '@connectrpc/connect-query'
import { authTransport } from '../transport'

export function useAcceptFamilyInvite() {
  return useMutation(acceptFamilyInvite, { transport: authTransport })
}
